/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map

/*Comportamiento boton agregar pack*/

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.product-card__plus-btn');
  if (!btn) return;

  const id = btn.dataset.variantId;
  const title = btn.dataset.title;
  const image = btn.dataset.image;
  const price = parseInt(btn.dataset.price);

  let customCart = JSON.parse(localStorage.getItem("customBundleCart")) || { items: [] };
  let totalQty = customCart.items.reduce((sum, i) => sum + i.quantity, 0);

  // Definir PACK_SIZE UNA VEZ
  const PACK_SIZE = window.bundlePackSize || 6;

  // Validación
  if (window.isBundleBuilderPage && totalQty >= PACK_SIZE) {
    alert(`Has alcanzado el máximo permitido para tu pack (${PACK_SIZE}).`);
    return;
  }

  // Agregar producto
  let existing = customCart.items.find(item => item.variantId == id);
  if (existing) {
    existing.quantity++;
  } else {
    customCart.items.push({
      variantId: id,
      title,
      image,
      price,
      quantity: 1
    });
  }

  localStorage.setItem("customBundleCart", JSON.stringify(customCart));
  document.dispatchEvent(new CustomEvent("customBundleUpdated"));

  // Texto del toast
  const textofinal = `Producto agregado <strong>${totalQty + 1} de ${PACK_SIZE}</strong>`;
  showToast(textofinal, "#008060");

});


/*FIN Comportamiento boton agregar pack*/

